var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.BModal, {
    attrs: {
      size: _setup.modalSize,
      title: _setup.modalTitle,
      "modal-class": "vue-need-bootstrap",
      lazy: "",
      centered: "",
      scrollable: "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ cancel }) {
          return [
            !_setup.showReasons && _vm.allowCanceling
              ? _c("div", { staticClass: "mb-3" }, [
                  _vm._v(
                    "\n            You are about to cancel your account for "
                  ),
                  _c("u", [_vm._v(_vm._s(_vm.store))]),
                  _vm._v(".\n            "),
                  _c("b", [
                    _vm._v(
                      "\n                If you cancel all your templates, libraries, and personalization information will be disconnected\n                from "
                    ),
                    _c("u", [_vm._v(_vm._s(_vm.store))]),
                    _vm._v("."),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.allowPausing,
                          expression: "allowPausing",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        "\n                If you wish to save this information to use it on your products later on you can\n                "
                      ),
                      _c("b", [
                        _vm._v("pause your account instead for $5 a month"),
                      ]),
                      _vm._v(
                        ". So you can come back whenever you are ready\n                without losing all your work.\n            "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              _setup.BModal,
              {
                attrs: {
                  title: "Payment failed",
                  "modal-class": "vue-need-bootstrap",
                  centered: "",
                  "no-close-on-esc": "",
                  "hide-header-close": "",
                  "no-close-on-backdrop": "",
                  "ok-only": "",
                },
                on: {
                  ok: function ($event) {
                    _setup.isVisible = false
                  },
                },
                model: {
                  value: _setup.showPaymentFailedAlert,
                  callback: function ($$v) {
                    _setup.showPaymentFailedAlert = $$v
                  },
                  expression: "showPaymentFailedAlert",
                },
              },
              [
                _vm._v(
                  "\n            Payment failed! Please try again with a new card.\n        "
                ),
              ]
            ),
            _vm._v(" "),
            !_setup.showReasons && !_vm.allowCanceling && _vm.allowPausing
              ? _c("div", { staticClass: "mb-3" }, [
                  _vm._v("\n            Your products on\n            "),
                  _c("b", [_c("u", [_vm._v(_vm._s(_vm.store))])]),
                  _vm._v(
                    "\n            will no longer have options and previews live, but all your work will be saved so you can come back\n            whenever you are ready and activate them.\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(_setup.ValidationObserver, {
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ valid }) {
                      return [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                              },
                            },
                          },
                          [
                            !_setup.showReasons
                              ? _c(
                                  "div",
                                  [
                                    _c(_setup.ValidationProvider, {
                                      attrs: {
                                        rules: "required|min:8",
                                        name: "Password",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ valid, errors }) {
                                              return [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    staticClass: "my-3",
                                                    attrs: {
                                                      id:
                                                        "current-password-input",
                                                      "label-cols": "3",
                                                      "content-cols": "9",
                                                      label: "Current password",
                                                      "label-for":
                                                        "current-password-input",
                                                      "invalid-feedback": _setup.invalidPassword
                                                        ? "Wrong password"
                                                        : errors[0],
                                                      state: _setup.invalidPassword
                                                        ? false
                                                        : errors[0]
                                                        ? false
                                                        : valid
                                                        ? true
                                                        : null,
                                                    },
                                                  },
                                                  [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id:
                                                          "current-password-input",
                                                        type: "password",
                                                        state: _setup.invalidPassword
                                                          ? false
                                                          : errors[0]
                                                          ? false
                                                          : valid
                                                          ? true
                                                          : null,
                                                        disabled:
                                                          _setup.processing,
                                                      },
                                                      model: {
                                                        value: _setup.password,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _setup.password = $$v
                                                        },
                                                        expression: "password",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.showReasons
                              ? _c(
                                  "div",
                                  [
                                    _c("div", { staticClass: "mb-2" }, [
                                      _vm._v(
                                        "\n                        Please help us understand your reasons for\n                        "
                                      ),
                                      _setup.currentAction === "cancel"
                                        ? _c("span", [_vm._v("canceling")])
                                        : _vm._e(),
                                      _setup.currentAction === "pause"
                                        ? _c("span", [_vm._v("pausing")])
                                        : _vm._e(),
                                      _vm._v(
                                        " so we can improve our service for the\n                        future:\n                    "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.allowCanceling
                                      ? _c(
                                          _setup.ValidationProvider,
                                          {
                                            attrs: {
                                              rules: "required",
                                              name: "Cancel Reason",
                                            },
                                          },
                                          [
                                            _c(
                                              "b-form-group",
                                              [
                                                _c(
                                                  "b-form-checkbox-group",
                                                  {
                                                    attrs: { stacked: "" },
                                                    model: {
                                                      value:
                                                        _setup.cancelReasons,
                                                      callback: function ($$v) {
                                                        _setup.cancelReasons = $$v
                                                      },
                                                      expression:
                                                        "cancelReasons",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "WANTED_TO_TEST",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Only wanted to test it"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "MISSING_FEATURE",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Missing a key feature I needed\n                                "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "SWITCHING_TOOL",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Switching to other personalization tool\n                                "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "NOT_SATISFIED_WITH_PRODUCTS",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "I was not satisfied with the results on my products"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "NOT_SATISFIED_WITH_SUPPORT",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "I was not satisfied with the support\n                                "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "TOO_COMPLICATED",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Too complicated to use"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "TOO_EXPENSIVE",
                                                        },
                                                      },
                                                      [_vm._v("Too expensive")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "SHUTTING_DOWN_STORE",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "I'm shutting down my store\n                                "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value: "OTHER",
                                                        },
                                                      },
                                                      [_vm._v("Other")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.allowCanceling && _vm.allowPausing
                                      ? _c(
                                          _setup.ValidationProvider,
                                          {
                                            attrs: {
                                              rules: "required",
                                              name: "Pause Reason",
                                            },
                                          },
                                          [
                                            _c(
                                              "b-form-group",
                                              [
                                                _c(
                                                  "b-form-checkbox-group",
                                                  {
                                                    attrs: { stacked: "" },
                                                    model: {
                                                      value:
                                                        _setup.pauseReasons,
                                                      callback: function ($$v) {
                                                        _setup.pauseReasons = $$v
                                                      },
                                                      expression:
                                                        "pauseReasons",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "STORE_NOT_LIVE",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "My store is not yet live"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "SALES_GONE_DOWN",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "My sales have gone down "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "BUSINESS_IS_SEASONAL",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "My business is seasonal\n                                "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "FOCUSING_ON_NON_CUSTOMILY_PRODUCTS",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "I’m focusing on other products that don't need Customily"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "NO_TIME_FOR_CUSTOMILY",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "I don’t have the time to use Customily right now\n                                "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value: "OTHER",
                                                        },
                                                      },
                                                      [_vm._v("Other")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _setup.cancelReasons.some(
                                      (r) => r === "OTHER"
                                    ) ||
                                    _setup.pauseReasons.some(
                                      (r) => r === "OTHER"
                                    )
                                      ? _c(_setup.ValidationProvider, {
                                          attrs: {
                                            rules: "required|min:10|max:10000",
                                            name: "Cancellation details",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({
                                                  valid,
                                                  errors,
                                                }) {
                                                  return [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        staticClass: "my-3",
                                                        attrs: {
                                                          id:
                                                            "cancel-details-input",
                                                          "label-cols": "3",
                                                          "content-cols": "9",
                                                          label:
                                                            "Cancellation details",
                                                          "label-for":
                                                            "cancel-details-input",
                                                          "invalid-feedback":
                                                            errors[0],
                                                          state: errors[0]
                                                            ? false
                                                            : valid
                                                            ? true
                                                            : null,
                                                        },
                                                      },
                                                      [
                                                        _c("b-form-textarea", {
                                                          attrs: {
                                                            id:
                                                              "cancel-detail-input",
                                                            state: errors[0]
                                                              ? false
                                                              : valid
                                                              ? true
                                                              : null,
                                                            disabled:
                                                              _setup.processing,
                                                            rows: "6",
                                                            "max-rows": "12",
                                                          },
                                                          model: {
                                                            value:
                                                              _setup.actionDetails,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _setup.actionDetails = $$v
                                                            },
                                                            expression:
                                                              "actionDetails",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _setup.errorMessage,
                                    expression: "errorMessage",
                                  },
                                ],
                                staticClass:
                                  "error-message w-100 pb-3 text-center",
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_setup.errorMessage) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            !_setup.showReasons
                              ? _c(
                                  "div",
                                  { staticClass: "modal-footer row pb-0" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "primary",
                                          type: "reset",
                                          disabled: _setup.processing,
                                        },
                                        on: { click: cancel },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        I changed my mind\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      _setup.LoaderBtn,
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.allowPausing,
                                            expression: "allowPausing",
                                          },
                                        ],
                                        attrs: {
                                          variant: "info",
                                          disabled: !valid || _setup.processing,
                                          loading: _setup.pausingSubscription,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _setup.goToReasons("pause")
                                          },
                                        },
                                      },
                                      [
                                        _vm.accountDisableMode
                                          ? _c("span", [
                                              _vm._v(
                                                "Pause account and save my work"
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.accountDisableMode
                                          ? _c("span", [
                                              _vm._v(
                                                "Pause store and save my work"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.allowCanceling
                                      ? _c(
                                          _setup.LoaderBtn,
                                          {
                                            attrs: {
                                              variant: "danger",
                                              "loading-text": "Saving",
                                              disabled:
                                                !valid || _setup.processing,
                                              loading:
                                                _setup.cancelingSubscription,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _setup.goToReasons(
                                                  "cancel"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm.accountDisableMode
                                              ? _c("span", [
                                                  _vm._v(
                                                    "Cancel and delete my " +
                                                      _vm._s(
                                                        _setup.templatesCount
                                                      ) +
                                                      " templates"
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.accountDisableMode
                                              ? _c("span", [
                                                  _vm._v("Cancel "),
                                                  _c("b", [
                                                    _vm._v(_vm._s(_vm.store)),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.showReasons
                              ? _c(
                                  "div",
                                  { staticClass: "modal-footer row pb-0" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "primary",
                                          type: "reset",
                                          disabled: _setup.processing,
                                        },
                                        on: { click: cancel },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        I changed my mind\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      _setup.LoaderBtn,
                                      {
                                        attrs: {
                                          variant: "danger",
                                          "loading-text": "Saving",
                                          disabled: !valid || _setup.processing,
                                          loading:
                                            _setup.cancelingSubscription ||
                                            _setup.pausingSubscription,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _setup.subscriptionSubmit(
                                              _setup.currentAction
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _setup.currentAction === "cancel"
                                                ? "Cancel account"
                                                : "Pause account"
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
    ]),
    model: {
      value: _setup.isVisible,
      callback: function ($$v) {
        _setup.isVisible = $$v
      },
      expression: "isVisible",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }